@if (avoinna()) {
  <div class="search-overlay" (mousedown)="taustaaKlikattu($event)">
    <div class="search-panel" role="dialog" aria-modal="true" cdkTrapFocus [attr.aria-label]="'asiakkaat.haku.modal-otsikko' | translate | async">
      <app-icon-button additionalClass="search-close" matIcon="close" (click)="sulje()" actionId="Asiakashaku: sulje"></app-icon-button>

      <div class="search-content">
        <div class="search-field">
          <mat-form-field>
            <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
            <mat-label>{{ 'asiakkaat.haku.hakukentan-placeholder' | translate | async }}</mat-label>
            <input type="text" matInput #hakukentta [formField]="hakuteksti" />
          </mat-form-field>
        </div>

        <div class="results">
          @if (haetaan()) {
            <div class="hint">{{ 'asiakkaat.haku.haetaan' | translate | async }}</div>
          } @else if (!hakusana()) {
            <div class="hint">{{ 'asiakkaat.haku.hakuohje' | translate | async }}</div>
          } @else if (tulokset().length === 0) {
            <div class="hint">{{ 'asiakkaat.haku.ei-tuloksia' | translate | async }}</div>
          } @else {
            <ul class="tulokset-lista">
              @for (asiakas of tulokset(); track asiakas.avain) {
                <li class="tulos-rivi" role="button" tabindex="0" (click)="avaaAsiakas(asiakas)" (keydown.enter)="avaaAsiakas(asiakas)" (keydown.space)="$event.preventDefault(); avaaAsiakas(asiakas)">
                  <div class="tulos-otsikko">{{ asiakas.nimi }}</div>
                  <div class="tulos-lisatiedot">
                    @if (asiakas.ytunnus) {
                      <span>{{ asiakas.ytunnus }}</span>
                    }
                    @if (annaOsoite(asiakas)) {
                      <span>{{ annaOsoite(asiakas) }}</span>
                    }
                    @if (asiakas.maa) {
                      <span>{{ asiakas.maa | lmaa | async }}</span>
                    }
                  </div>
                </li>
              }
            </ul>
            <mat-paginator class="haku-paginator" [length]="kokonaismaara()" [pageIndex]="sivu" [pageSize]="sivunKoko" [pageSizeOptions]="sivukoot" showFirstLastButtons (page)="sivuMuuttui($event)"></mat-paginator>
          }
        </div>
      </div>
    </div>
  </div>
}
